"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkImageSize = void 0;
exports.UploadFields = UploadFields;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const showBigSizeNotification = (intl, imageSize) => {
    antd_1.notification.error({
        message: intl.formatMessage({
            id: 'profile.resume.notification',
        }),
        description: `${intl.formatMessage({
            id: 'profile.resume.max_img_size',
        })} ${imageSize}MB`,
        placement: 'bottomRight',
    });
};
const checkImageSize = (e, imageSizeMb, intl) => {
    const isImageSizeInBounds = e.size / 1024 / 1024 < imageSizeMb;
    if (!isImageSizeInBounds) {
        showBigSizeNotification(intl, imageSizeMb);
        throw new Error('Image too large. Maximal size is 1 MB');
    }
    return isImageSizeInBounds;
};
exports.checkImageSize = checkImageSize;
function UploadFields({ intl, image, setImage, titleImage, setTitleImage }) {
    return ((0, jsx_runtime_1.jsxs)(antd_1.Row, { gutter: [16, 16], children: [(0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, md: 12, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                        id: 'registration.registration_form.image',
                    }), name: types_1.CompanyInfoEditFormField.image, children: (0, jsx_runtime_1.jsx)(elements_1.ImageUpload, { name: "image", accept: "image/*", aspect: 1, cropSize: { width: 600, height: 600 }, beforeUpload: e => (0, exports.checkImageSize)(e, 1, intl), wholeFileList: image, setFileList: setImage, modalTitle: `${intl.formatMessage({
                            id: 'registration.registration_form.upload_modal_title',
                        })} (1:1, max. 1MB)` }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, md: 12, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                        id: 'registration.registration_form.title_image',
                    }), name: types_1.CompanyInfoEditFormField.title_image, children: (0, jsx_runtime_1.jsx)(elements_1.ImageUpload, { name: "title_image_url", accept: "image/*", aspect: 6 / 1, cropSize: { width: 1200, height: 200 }, beforeUpload: e => (0, exports.checkImageSize)(e, 2, intl), wholeFileList: titleImage, setFileList: setTitleImage, modalTitle: `${intl.formatMessage({
                            id: 'registration.registration_form.upload_modal_title',
                        })} (6:1, max. 1MB)` }) }) })] }));
}
